<template>
    <div>
        <page-title>编辑盗版信息</page-title>
        <page-body>
            <el-form v-loading="loading" :model="form" :rules="rules" ref="form">
                <el-form-item label="域名" prop="domain">
                    <el-input v-model="form.domain" @blur="searchSubject"/>
                </el-form-item>
                <el-form-item label="备案主体" prop="subject">
                    <el-input v-model="form.subject"></el-input>
                </el-form-item>
                <el-form-item label="备注" prop="remark">
                    <el-input v-model="form.remark"/>
                </el-form-item>
                <el-form-item>
                    <el-button :loading="btnLoading" @click="submit('form')" type="primary">{{form.id ? '保存' : '添加盗版域名'}}
                    </el-button>
                </el-form-item>
            </el-form>
        </page-body>
    </div>
</template>

<style scoped>
    .host-ip-row {
        margin-top: 25px;
    }

    .host-ip-row:first-child {
        margin-top: 0;
    }
</style>

<script>
import axios from '@/axios'

export default {
    data() {
        return {
            loading: false,
            btnLoading: false,
            detail: null,
            rules: {
                domain: [
                    {required: true, message: '请填写域名。'}
                ],
                subject: [
                    {required: true, message: '请填写备案主体。'}
                ]
            },
            form: {
                domain: null,
                subject: null,
                remark: ''
            }
        }
    },
    created() {
        if (this.$route.query.id) {
            this.form.id = this.$route.query.id
            this.loadData()
        }
    },
    methods: {
        loadData() {
            this.loading = true
            axios({
                url: 'admin/illegal/detail',
                params: {
                    id: this.form.id
                }
            }).then(e => {
                this.loading = false
                if (e.data.code === 0) {
                    this.form.domain = e.data.data.domain
                    this.form.subject = e.data.data.subject
                    this.form.remark = e.data.data.remark
                } else {
                    this.$message.error(e.data.msg)
                }
            })
        },
        submit(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.btnLoading = true
                    axios({
                        url: 'admin/illegal/update',
                        method: 'post',
                        data: this.form
                    }).then(e => {
                        this.btnLoading = false
                        if (e.data.code === 0) {
                            this.$message.success('保存成功。')
                            this.$router.push('/dashboard/admin/illegal/index')
                        } else {
                            this.$message.error(e.data.msg)
                        }
                    })
                }
            })
        },
        searchSubject() {
            axios({
                url: 'user/host/subject',
                params: {
                    domain: this.form.domain
                },
                method: 'get'
            }).then(e => {
                if (e.data.code === 0) {
                    this.form.subject = e.data.data
                } else {
                    this.$message.error(e.data.msg)
                }
            })
        }
    }
}
</script>
